/*jslint browser: true*/
/*global $, jQuery, moment*/

$(document).ready(function () {
    "use strict";
    var pageBar = $('#page-bar');

    if ($(window).scrollTop() > 10) {
        pageBar.addClass('fixed');
    }

    $(window).scroll(function () {
        if ($(window).scrollTop() > 10) {
            pageBar.addClass('fixed');
        } else {
            pageBar.removeClass('fixed');
        }
    });

    pageBar.find('.dropdown-menu a').on('click', function (e) {
        // Pokd neni odkaz, ma mit data, odesleme jeko post
        if ($(this).data('button-name').length) {
            e.preventDefault();
            $('.tempHiddenPost').remove();
            $('form').not('#timetracker').append($('<input>').attr('type', 'hidden').attr('name', $(this).data('button-name')).addClass('tempHiddenPost')).submit();
        }
    });

    pageBar.find('button').on('click', function () {
        $('.tempHiddenPost').remove();
    });

    $('nav-tabs').find('a').click(function (e) {
        e.preventDefault();
        $(this).tab('show');
    });
});
